import { Common } from '@stockbit/ui';
import PropTypes from 'prop-types';

const { Text, PopoverTitleWrapper } = Common;

const MenuProfileTitle = ({ name }) => (
  <PopoverTitleWrapper>
    <Text family="bold" size="16px" color="#000000A6">
      {name}
    </Text>
  </PopoverTitleWrapper>
);

MenuProfileTitle.propTypes = {
  name: PropTypes.string,
};

MenuProfileTitle.defaultProps = {
  name: '',
};

export default MenuProfileTitle;
